import { useEffect, useState } from "react";
import { UserInfoUtil } from "../../utils/checkSession";

const SessionTimer = () => {
    const expiryTime = UserInfoUtil.get().expires_in;

    const normalizeExpiry = () => {
        // handles both seconds and milliseconds
        return expiryTime > 1e12
        ? Math.floor(expiryTime / 1000)
        : expiryTime;
    };

    const [timeLeft, setTimeLeft] = useState(getRemainingTime());

    function getRemainingTime() {
        const now = Math.floor(Date.now() / 1000);
        const diff = normalizeExpiry() - now;

        return diff > 0 ? diff : 0;
    }

    useEffect(() => {
        const interval = setInterval(() => {
        setTimeLeft(getRemainingTime());
        }, 1000);

        return () => clearInterval(interval);
    }, [expiryTime]);

    function formatTime(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0"
        )}:${String(secs).padStart(2, "0")}`;
    }

    const isExpired = timeLeft === 0;
    const isWarning = timeLeft > 0 && timeLeft <= 60;

    return (
        <div
        style={{
            color: isExpired ? "gray" : isWarning ? "red" : "black",
        }}
        >
        {isExpired ? "Expired" : `Session Time Remaining: ${formatTime(timeLeft)}`}
        </div>
    );
}

export default SessionTimer